package gr.tech.pdfgenerator.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Resize
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaEye
import com.varabyte.kobweb.silk.components.icons.fa.FaEyeSlash
import com.varabyte.kobweb.silk.components.icons.fa.FaGripVertical
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.components.icons.fa.FaTrash
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.pdfgenerator.infrastructure.data.GeneratorData
import gr.tech.pdfgenerator.models.TierThreeEquipmentDTO
import gr.tech.pdfgenerator.styles.SimpleSpanStyle
import gr.tech.pdfgenerator.styles.T3AddRowButtonStyle
import gr.tech.pdfgenerator.styles.T3DeliverableColumnPreview
import gr.tech.pdfgenerator.styles.T3DeliverableRowPreview
import gr.tech.pdfgenerator.styles.T3DeliverableTableStyle
import gr.tech.pdfgenerator.styles.T3DeliverableTextPreview
import gr.tech.pdfgenerator.styles.T3InputTitleStyle
import gr.tech.pdfgenerator.styles.T3TableControlCellStyle
import gr.tech.pdfgenerator.styles.T3TableDeleteButtonStyle
import gr.tech.pdfgenerator.styles.T3TableGripStyle
import gr.tech.pdfgenerator.styles.Theme
import gr.tech.pdfgenerator.styles.noBorder
import gr.tech.pdfgenerator.styles.stringInputStyle
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import gr.tech.pdfgenerator.util.INPUTS
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun tierThreeInputsSection() {
    var tierThreeState by GeneratorData.tierThreeState

    Column(
        modifier = Modifier.width(875.px).padding(bottom = 3.cssRem),
        horizontalAlignment = Alignment.Start
    ) {

        // Address Overwrite Section
        Row(Modifier.margin(bottom = 12.px), verticalAlignment = Alignment.CenterVertically) {
            CheckboxInput(
                checked = tierThreeState.addressOverwriteCheck,
                attrs = Modifier
                    .width(15.px)
                    .height(15.px)
                    .margin(right = 10.px)
                    .onClick {
                        tierThreeState = tierThreeState.copy(
                            addressOverwriteCheck = !tierThreeState.addressOverwriteCheck
                        )
                    }
                    .toAttrs()
            )

            SpanText(
                text = "Overwrite Company Address (Will be displayed instead)",
                modifier = SimpleSpanStyle.toModifier().cursor(Cursor.Help)
                    .attrsModifier {
                        title("Option to specify a different Company Address than reported in General Inputs.")
                    }
            )
        }

        if (tierThreeState.addressOverwriteCheck) {
            Row(
                modifier = Modifier
                    .gap(6.px)
                    .fillMaxWidth()
            ) {
                StringInputLabel(
                    label = "State",
                    id = INPUTS.TIER_THREE.t3StateOverwrite,
                    initialValue = tierThreeState.stateOverwrite,
                ) {
                    tierThreeState = tierThreeState.copy(stateOverwrite = it)
                }

                StringInputLabel(
                    label = "Address",
                    id = INPUTS.TIER_THREE.t3AddressOverwrite,
                    initialValue = tierThreeState.addressOverwrite,
                ) {
                    tierThreeState = tierThreeState.copy(addressOverwrite = it)
                }

                StringInputLabel(
                    label = "City",
                    id = INPUTS.TIER_THREE.t3CityOverwrite,
                    initialValue = tierThreeState.cityOverwrite,
                ) {
                    tierThreeState = tierThreeState.copy(cityOverwrite = it)
                }

                StringInputLabel(
                    label = "Zip",
                    id = INPUTS.TIER_THREE.t3ZipOverwrite,
                    initialValue = tierThreeState.zipOverwrite,
                ) {
                    tierThreeState = tierThreeState.copy(zipOverwrite = it)
                }
            }

            HorizontalDivider()
        }

        // Rebate Proposal Overwrite / Toggle Section
        Row(Modifier.margin(bottom = 12.px), verticalAlignment = Alignment.CenterVertically) {
            CheckboxInput(
                checked = (tierThreeState.proposalShowInPDF),
                attrs = Modifier.width(15.px).height(15.px).margin(right = 10.px)
                    .onClick {
                        tierThreeState = tierThreeState.copy(
                            proposalShowInPDF = !tierThreeState.proposalShowInPDF
                        )
                    }
                    .toAttrs()
            )

            SpanText(
                text = "Show Lighting Proposal Section",
                modifier = SimpleSpanStyle.toModifier().cursor(Cursor.Help)
                    .attrsModifier {
                        title("Show Section inside PDF, showing rebate calculations.")
                    }
            )
        }

        if (tierThreeState.proposalShowInPDF) {

            Row(Modifier.margin(bottom = 12.px), verticalAlignment = Alignment.CenterVertically) {
                CheckboxInput(
                    checked = (tierThreeState.proposalOverwriteCheck),
                    attrs = Modifier.width(15.px).height(15.px).margin(right = 10.px)
                        .onClick {
                            tierThreeState = tierThreeState.copy(
                                proposalOverwriteCheck = !tierThreeState.proposalOverwriteCheck
                            )
                        }
                        .toAttrs()
                )

                SpanText(
                    text = "Overwrite Lighting Proposal Calculations",
                    modifier = SimpleSpanStyle.toModifier().cursor(Cursor.Help)
                        .attrsModifier {
                            title("Option to specify different Rebate Summary values than calculated from 'Lighting Proposal' inputs. This does not contain any calculations, input pre-calculated values.")
                        }
                )
            }

            Column(modifier = Modifier.gap(6.px).fillMaxWidth()) {
                DollarInputLabel(
                    label = "Rebate Amount",
                    id = INPUTS.TIER_THREE.t3ProposalOverwrite,
                    initialValue = tierThreeState.rebatesOverwrite.toString()
                ) {
                    tierThreeState = tierThreeState.copy(rebatesOverwrite = it)
                }

                DollarInputLabel(
                    label = "Net Project Cost",
                    id = INPUTS.TIER_THREE.t3ProjectCostOverwrite,
                    initialValue = tierThreeState.projectCostOverwrite.toString()
                ) {
                    tierThreeState = tierThreeState.copy(projectCostOverwrite = it)
                }

                DollarInputLabel(
                    label = "Annual Savings",
                    id = INPUTS.TIER_THREE.t3TotalAnnualSavingsOverwrite,
                    initialValue = tierThreeState.totalAnnualSavingsOverwrite.toString()
                ) {
                    tierThreeState = tierThreeState.copy(totalAnnualSavingsOverwrite = it)
                }

                DollarInputLabel(
                    label = "Total Savings (10 yrs)",
                    id = INPUTS.TIER_THREE.t3CummCashFlowListOverwrite,
                    initialValue = tierThreeState.cummCashFlowListOverwrite.toString()
                ) {
                    tierThreeState = tierThreeState.copy(cummCashFlowListOverwrite = it)
                }

                PercentInputLabel(
                    label = "Annualized ROI",
                    id = INPUTS.TIER_THREE.t3TotalAnnualSavingsOverwrite,
                    initialValue = tierThreeState.annualizedROIOverwrite
                ) {
                    tierThreeState = tierThreeState.copy(annualizedROIOverwrite = it)
                }

                DoubleInputLabel(
                    label = "Simple Payback",
                    id = INPUTS.TIER_THREE.t3SimplePaybackOverwrite,
                    initialValue = tierThreeState.simplePaybackOverwrite
                ) {
                    tierThreeState = tierThreeState.copy(simplePaybackOverwrite = it)
                }
            }
        }

        HorizontalDivider()

        H3(attrs = T3InputTitleStyle.toAttrs()) {
            Text("Qualifying Electric Energy Saving Equipment")
        }

        StringInputLabel(
            label = "Green Rebates Representative Name",
            id = INPUTS.TIER_THREE.tierGrRepInput,
            initialValue = tierThreeState.grRepName
        ) {
            tierThreeState = tierThreeState.copy(grRepName = it)
        }

        StringInputLabel(
            label = "Representative Title",
            id = INPUTS.TIER_THREE.teirGrRepTitleInput,
            initialValue = tierThreeState.grRepTitle
        ) {
            tierThreeState = tierThreeState.copy(grRepTitle = it)
        }

        HorizontalDivider()

        PercentInputLabel(
            label = "Lighting (%)",
            id = INPUTS.TIER_THREE.tierLightingInput,
            placeholder = tierThreeState.lightingPercentage,
            initialValue = tierThreeState.lightingPercentage
        ) {
            tierThreeState = tierThreeState.copy(lightingPercentage = it)
        }

        PercentInputLabel(
            label = "Dehumidifier (%)",
            id = INPUTS.TIER_THREE.tierDehumidifierInput,
            placeholder = tierThreeState.dehumidifierPercentage,
            initialValue = tierThreeState.dehumidifierPercentage
        ) {
            tierThreeState = tierThreeState.copy(dehumidifierPercentage = it)
        }

        PercentInputLabel(
            label = "Heat Curtains (%)",
            id = INPUTS.TIER_THREE.tierDehumidifierInput,
            placeholder = tierThreeState.heatCurtainPercentage,
            initialValue = tierThreeState.heatCurtainPercentage
        ) {
            tierThreeState = tierThreeState.copy(heatCurtainPercentage = it)
        }

        PercentInputLabel(
            label = "HVAC (%)",
            id = INPUTS.TIER_THREE.tierDehumidifierInput,
            placeholder = tierThreeState.hvacPercentage,
            initialValue = tierThreeState.hvacPercentage
        ) {
            tierThreeState = tierThreeState.copy(hvacPercentage = it)
        }

        HorizontalDivider()

        H3(attrs = T3InputTitleStyle.toAttrs()) {
            Text("Equipment")
        }

        EquipmentTableInput(
            equipment = tierThreeState.equipmentList,
            onUpdate = { tierThreeState = tierThreeState.copy(equipmentList = it) },
        )

        HorizontalDivider()
    }
}

@Composable
private fun EquipmentTableInput(
    equipment: List<TierThreeEquipmentDTO>,
    onUpdate: (List<TierThreeEquipmentDTO>) -> Unit,
) {
    var draggedIndex by remember { mutableStateOf(-1) }
    var dragOverIndex by remember { mutableStateOf(-1) }

    Table(attrs = T3DeliverableTableStyle.toAttrs()) {
        Tr {
            Th(T3TableControlCellStyle.toAttrs()) {}
            Th(T3DeliverableTextPreview.toModifier().padding(4.px).width(75.px).toAttrs()) { Text("Phase") }
            Th(T3DeliverableTextPreview.toModifier().padding(4.px).minWidth(150.px).toAttrs()) { Text("Equipment") }
            Th(T3DeliverableTextPreview.toModifier().padding(4.px).minWidth(250.px).toAttrs()) { Text("Notes") }
            Th(T3TableControlCellStyle.toAttrs()) {}
        }

        equipment.forEachIndexed { index, item ->
            Tr(
                attrs = T3DeliverableRowPreview.toModifier()
                    .then(
                        if (dragOverIndex == index && dragOverIndex != draggedIndex)
                            Modifier.borderTop(3.px, LineStyle.Solid, Theme.MediumGreen.rgb)
                        else Modifier
                    )
                    .onDragOver { it.preventDefault(); dragOverIndex = index }
                    .onDragLeave { if (dragOverIndex == index) dragOverIndex = -1 }
                    .onDrop {
                        if (draggedIndex != -1 && draggedIndex != dragOverIndex) {
                            val list = equipment.toMutableList()
                            val moved = list.removeAt(draggedIndex)
                            list.add(
                                if (dragOverIndex > draggedIndex) dragOverIndex - 1 else dragOverIndex,
                                moved
                            )
                            onUpdate(list)
                        }
                        draggedIndex = -1
                        dragOverIndex = -1
                    }
                    .toAttrs()
            ) {
                Td(
                    attrs = T3TableControlCellStyle.toModifier()
                        .draggable(true)
                        .onDragStart { draggedIndex = index }
                        .toAttrs()
                ) {
                    FaGripVertical(modifier = T3TableGripStyle.toModifier())
                }
                Td(T3DeliverableColumnPreview.toModifier().minWidth(75.px).padding(0.px).toAttrs()) {
                    TextArea(
                        value = item.phase,
                        attrs = stringInputStyle.toModifier().noBorder().resize(Resize.None)
                            .overflow(Overflow.Hidden).toAttrs {
                                ref { el ->
                                    el.style.height = "auto"
                                    el.style.height = "${el.scrollHeight}px"
                                    onDispose {}
                                }
                                onInput { event ->
                                    event.target.style.height = "auto"
                                    event.target.style.height = "${event.target.scrollHeight}px"
                                    val list = equipment.toMutableList()
                                    list[index] = list[index].copy(phase = event.value)
                                    onUpdate(list)
                                }
                            }
                    )
                }
                Td(T3DeliverableColumnPreview.toModifier().minWidth(150.px).padding(0.px).toAttrs()) {
                    TextArea(
                        value = item.equipment,
                        attrs = stringInputStyle.toModifier().noBorder().resize(Resize.None)
                            .overflow(Overflow.Hidden).toAttrs {
                                ref { el ->
                                    el.style.height = "auto"
                                    el.style.height = "${el.scrollHeight}px"
                                    onDispose {}
                                }
                                onInput { event ->
                                    event.target.style.height = "auto"
                                    event.target.style.height = "${event.target.scrollHeight}px"
                                    val list = equipment.toMutableList()
                                    list[index] = list[index].copy(equipment = event.value)
                                    onUpdate(list)
                                }
                            }
                    )
                }
                Td(T3DeliverableColumnPreview.toModifier().minWidth(250.px).padding(0.px).toAttrs()) {
                    TextArea(
                        value = item.notes,
                        attrs = stringInputStyle.toModifier().noBorder().resize(Resize.None)
                            .overflow(Overflow.Hidden).toAttrs {
                                ref { el ->
                                    el.style.height = "auto"
                                    el.style.height = "${el.scrollHeight}px"
                                    onDispose {}
                                }
                                onInput { event ->
                                    event.target.style.height = "auto"
                                    event.target.style.height = "${event.target.scrollHeight}px"
                                    val list = equipment.toMutableList()
                                    list[index] = list[index].copy(notes = event.value)
                                    onUpdate(list)
                                }
                            }
                    )
                }
                Td(T3TableControlCellStyle.toAttrs()) {
                    Button(
                        attrs = T3TableDeleteButtonStyle.toModifier()
                            .onClick {
                                val list = equipment.toMutableList()
                                list.removeAt(index)
                                onUpdate(list)
                            }
                            .toAttrs()
                    ) {
                        FaTrash(size = IconSize.XS)
                    }
                }
            }
        }
    }

    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Start
    ) {
        if (equipment.size < 8) {
            Button(
                attrs = T3AddRowButtonStyle.toModifier()
                    .onClick { onUpdate(equipment + TierThreeEquipmentDTO()) }
                    .toAttrs()
            ) {
                FaPlus(modifier = Modifier.margin(right = 6.px))
                Text("Add Equipment")
            }
        }

        SpanText(
            text = "Total: ${equipment.size} / 8",
            modifier = Modifier
                .fontFamily(FONT_FAMILY)
                .fontSize(1.cssRem)
                .fontWeight(FontWeight.Bold)
                .margin(left = 8.px)
        )
    }
}
